import React, { useEffect, useState } from 'react';
import {
  Form,
  TextInput,
  Button,
  PasswordInput,
  InlineNotification,
} from '@carbon/react';
import axios from 'axios';
import { filterServices, selectSessionExpired, setMe, setSessionExpired, setToken } from '../AppSlice';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { getTokenData, saveToken } from '../data/auth';
import { endpoints, GatewayIp } from '../data/endpoints';
import { useNavigate, useLocation } from 'react-router-dom';

const SESSION_EXPIRED_STORAGE_KEY = 'session_expired';

const LoginForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const sessionExpired = useAppSelector(selectSessionExpired);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as any)?.from || '/';

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_EXPIRED_STORAGE_KEY) === 'true') {
      dispatch(setSessionExpired(true));
      sessionStorage.removeItem(SESSION_EXPIRED_STORAGE_KEY);
    }
  }, [dispatch]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(setSessionExpired(false));
    sessionStorage.removeItem(SESSION_EXPIRED_STORAGE_KEY);

    try {
      const response = await axios.post(GatewayIp + endpoints.auth.login, {
        username,
        password,
      });

      const token = response.data.token;
      saveToken(token);
      dispatch(setToken(token));
      const tokenData = getTokenData(token);
      dispatch(setMe({ username: tokenData.sub, name: tokenData.sub, isLogin: true, roles: (tokenData as any).authorities ?? [], permissions: (tokenData as any).permissions ?? [] }));
      dispatch(filterServices());
      navigate(from, { replace: true });
    } catch (err) {
      setError('Invalid credentials');
    }
  };

  return (
    <div className="login-container">
      <Form onSubmit={handleLogin}>
        <h2 className="login-title">Login</h2>

        {sessionExpired && (
          <InlineNotification
            kind="warning"
            title="Session Expired"
            subtitle="Your session has expired. Please log in again."
            onCloseButtonClick={() => {
              dispatch(setSessionExpired(false));
              sessionStorage.removeItem(SESSION_EXPIRED_STORAGE_KEY);
            }}
          />
        )}

        {error && (
          <InlineNotification
            kind="error"
            title="Login Error"
            subtitle={error}
            onCloseButtonClick={() => setError(null)}
          />
        )}

        <TextInput
          id="username"
          labelText="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />

        <div style={{ marginTop: 20 }}>
          <PasswordInput
            id="password"
            labelText="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <Button type="submit" className="login-button">
          Log in
        </Button>
      </Form>
    </div>
  );
};

export default LoginForm;
